import React from 'react';
import * as classes from './loader.module.css';

export default function Loader() {
  return (
    <div className={classes.container}>
      <img
        className={classes.loader}
        alt="Loading..."
        src="https://www.zomato.com/blog/wp-content/themes/blog/img/loader.gif.pagespeed.ce.h-ESHYdZ9t.gif"
      />
    </div>
  );
}
